import ResponseHelper from '@/helpers/responseHelper';
import api from '@/store/api';

// #region : Get Entities :
/**
 * Gets a list of available systems
 * @param {*} param0
 */
const getAvailableSystems = ({ commit }) => {
  const url = '/SystemDefinition/GetAvailableSystemDefinitions';

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'getAvailableSystems');

    if (valid) {
      commit('hydrateAvailableSystemDefinitions', response.data);
    } else {
      return response.Errors;
    }
  });
};
/**
 * Gets a list of available subsystems
 * @param {*} param0
 */
const getAvailableSubsystems = ({ state, commit }, systemId) => {
  commit('setAvailableSubsystemsLoading', true);
  commit('hydrateAvailableSubsystemDefinitions', []);
  let url = '/SubsystemDefinition/GetAvailableSubsystemDefinitions/' + systemId;

  // add userType if present on Project
  if (state.currentProject.projectSettingModels.find((x) => x.name === 'UserType')) {
    url += '?userType=' + state.currentProject.projectSettingModels.find((x) => x.name === 'UserType').value;
  }

  return api.get(url).then((response) => {
    commit('setAvailableSubsystemsLoading', false);
    commit('hydrateAvailableSubsystemDefinitions', response.data);
  });
};
/**
 * Queries server for list of projects
 * @param {*} param0
 */
const getProjects = ({ commit }) => {
  commit('setProjectsLoading', true);

  const url = '/Project/List';

  return api.get(url).then((response) => {
    commit('hydrateProjects', response.data);
  });
};
const getProjectSettingDefinitions = ({ commit }) => {
  const url = '/Project/SettingDefinitions';

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'getProjectSettingDefinitions');

    if (valid) {
      commit('hydrateProjectSettingDefinitions', response.data.projectSettingModels);
    } else {
      return response.Errors;
    }
  });
};
/**
 * Queries server for project data
 * @param {*} param0
 * @param {*} projectId
 */
const getProject = ({ commit }, payload) => {
  //commit('resetCurrentProject');

  const url = '/Project/Details/' + payload.projectId;

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'getProject');

    if (valid) {
      if (payload.returnData) {
        commit('hydrateCurrentProject', response.data);
        return response.data;
      } else {
        commit('hydrateCurrentProject', response.data);
      }
    } else {
      return response.Errors;
    }
  });
};
/**
 * Gets a list of systems for input project
 * @param {*} param0
 */
const getSystems = ({ commit }, payload) => {
  commit('setSystemsLoading', true);
  commit('resetCurrentSystem');

  const url = '/System/List/' + payload.projectId;

  return api
    .get(url)
    .then((response) => {
      if (payload.returnData) {
        return response.data;
      } else {
        commit('hydrateSystems', response.data);
      }
    })
    .finally(() => {
      commit('setSystemsLoading', false);
    });
};
/**
 * Gets a list of systems for input project
 * @param {*} param0
 */
const getSystemsForCheckout = ({ commit }, payload) => {
  commit('setSystemsLoading', true);
  commit('resetCurrentSystem');

  const url = '/System/ListForCheckout/' + payload.projectId;

  return api.get(url).then((response) => {
    return response.data;
  });
};
/**
 *Gets a list of subsystems for input system
 * @param {*} param0
 * @param {*} systemId
 */
const getSubsystems = ({ commit }, payload) => {
  commit('setSubsystemsLoading', true);
  commit('resetCurrentSubsystem');

  const url = '/Subsystem/List/' + payload.systemId;

  return api
    .get(url)
    .then((response) => {
      commit('setSubsystemsLoading', false);
      if (payload.returnData) {
        return response.data;
      } else {
        commit('hydrateSubsystems', {
          systemId: payload.systemId,
          records: response.data
        });
        return response.data;
      }
    })
    .finally(() => {
      commit('setSubsystemsLoading', false);
    });
};
/**
 *Gets a list of components for input subsystem
 * @param {*} param0
 * @param {*} subsystemId
 */
const getStepComponent = ({ dispatch, state, commit }, payload) => {
  // get componentId from steps
  var currentStep = state.currentSubsystemSteps[payload.stepIndex];
  if (!currentStep) {
    // console.log('currentStep not found for ' + payload.stepIndex);
    dispatch('app/showError', 'Error loading page, please try again', {
      root: true
    });
    return;
  }
  const url = '/Component/Details/' + currentStep.componentDefinitionId + '?subsystemId=' + payload.subsystemId;

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'getComponents');

    if (valid) {
      commit('hydrateStepComponent', response.data);
      return response.data;
    } else {
      return response.Errors;
    }
  });
};
/**
 * Returns a full subsystem tree with children
 * @param {*} param0
 * @param {*} subsystemId
 */
const getSubsystemDetails = ({ commit }, subsystemId) => {
  const url = '/Subsystem/Details/' + subsystemId;

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'getSubsystemDetails');

    if (valid) {
      return response.data;
    } else {
      return response.Errors;
    }
  });
};
/**
 * Gets steps for input subsystem
 * @param {*} param0
 * @param {*} subsystemId
 * @returns
 */
const getSubsystemSteps = ({ commit }, payload) => {
  commit('setIsLoadingSubsystemSteps', true);

  const url = '/Subsystem/StepsForSubsystem/' + payload.subsystemId;

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'getComponents');
    commit('setIsLoadingSubsystemSteps', false);

    if (valid) {
      commit('hydrateSubsystemSteps', response.data);
    } else {
      return response.Errors;
    }
  });
};
/**
 * Loads specified system from currentProject
 * @param {*} param0
 * @param {*} systemId
 */
const getSystem = ({ state, commit }, systemId) => {
  commit('setCurrentSystemLoading', true);
  commit('resetCurrentSystem');

  let system = state.systems.find((x) => x.id === systemId);
  if (system) {
    commit('hydrateCurrentSystem', system);
  } else {
    setTimeout(() => {
      commit(
        'app/showToast',
        {
          color: 'error',
          message: 'Could not find system ' + systemId + ' in current project',
          timeout: 5000
        },
        { root: true }
      );
    });
  }
};
/**
 * Loads specified subsystem from currentProject
 * @param {*} param0
 * @param {*} systemId
 */
const getSubsystem = ({ state, commit }, payload) => {
  commit('setCurrentSubsystemLoading', true);
  commit('resetCurrentSubsystem', payload.resetSteps);

  let subsystem = state.subsystems[`subsystem_${payload.systemId}`].find((x) => x.id == payload.subsystemId);
  if (subsystem) {
    commit('hydrateCurrentSubsystem', subsystem);
  } else {
    setTimeout(() => {
      commit(
        'app/showToast',
        {
          color: 'error',
          message: 'Could not find subsystem ' + payload.subsystemId + ' in current system',
          timeout: 5000
        },
        { root: true }
      );
    });
  }
  commit('setCurrentSubsystemLoading', false);
};
// #endregion

// #region : Actions :
/**
 * Selects a given product and submits update to configurator
 * @param {*} param0
 * @param {*} productId
 */
const validateComponent = ({ dispatch, state, commit }, action) => {
  // deep clone component
  if (!state.currentSubsystemStepComponent) return;
  const currentComponent = state.currentSubsystemStepComponent;
  if (action) {
    currentComponent.action = action;
  }

  // convert setting values to strings to prevent raw booleans from being submitted
  currentComponent.componentSettingModels.forEach((setting) => {
    setting.value = setting.value ? setting.value.toString() : null;
  });

  let newComponent = JSON.parse(JSON.stringify(currentComponent));

  const url = '/Configurator/ValidateComponent';
  const params = newComponent;

  return api.post(url, params).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'validateComponent');
    if (valid) {
      return response.data;
    } else {
      dispatch('app/showError', response.Errors, { root: true });
      return response.Errors;
    }
  });
};
/**
 * Refreshes the current projects higher level pricing and status data after a component update
 * @param {*} param0
 */
const refreshTreeSummaryData = ({ state, commit }) => {
  if (state.currentProject == null) return;
  const url = '/Project/PricingAndStatus/' + state.currentProject.id;

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'refreshTreeSummaryData');

    if (valid) {
      commit('refreshTreeSummaryData', response.data);
    } else {
      return response.Errors;
    }
  });
};
/**
 * Saves a configured product accessory
 * @param {*} param0
 */
const configureProductAccessory = ({ state, dispatch, commit }, payload) => {
  commit('setAccessoryLoading', true);

  const url = '/Configurator/ConfigureProductAccessory';
  const params = payload.accessory;

  return api.post(url, params).then((response) => {
    commit('setAccessoryLoading', false);
    const valid = ResponseHelper.processResponse(response, commit, 'configureProductAccessory') && response.data;
    if (valid) {
      const selectedProduct = state.currentSubsystemStepComponent.productModels.find((x) => x.selected);
      const originalAccessory = selectedProduct ? selectedProduct.productAccessoryModels[payload.index] : null;

      // update matching accessory
      commit('refreshAccessory', {
        originalAccessory: originalAccessory,
        updatedAccessory: response.data,
        index: payload.index
      });
      return response.data;
    } else {
      dispatch('app/showError', response.Errors, { root: true });
      return response.Errors;
    }
  });
};
/**
 * Saves a configured product
 * @param {*} param0
 */
const configureProduct = ({ dispatch, commit }, payload) => {
  commit('setProductLoading', true);

  const url = '/Configurator/ConfigureProduct';
  const params = payload.product;

  return api.post(url, params).then((response) => {
    commit('setProductLoading', false);
    const valid = ResponseHelper.processResponse(response, commit, 'configureProduct') && response.data;
    if (valid) {
      // update matching product
      commit('refreshProduct', {
        updatedProduct: response.data
      });
      return response.data;
    } else {
      dispatch('app/showError', response.Errors, { root: true });
      return response.Errors;
    }
  });
};
/**
 * Duplicates input accessory
 * @param {*} param0
 * @param {Object} payload  Properties:  accessory, index
 */
const duplicateAccessory = ({ dispatch, commit }, payload) => {
  commit('setAccessoryLoading', true);

  const url = '/Configurator/DuplicateProductAccessory';
  const params = payload.accessory;

  return api.post(url, params).then((response) => {
    commit('setAccessoryLoading', false);
    const valid = ResponseHelper.processResponse(response, commit, 'duplicateAccessory') && response.data;
    if (valid) {
      // update matching accessory
      commit('addAccessory', {
        newAccessory: response.data,
        index: payload.index
      });
      return response.data;
    } else {
      dispatch('app/showError', response.Errors, { root: true });
      return response.Errors;
    }
  });
};
/**
 * Posts currentProject to the Server
 * @param {*} param0
 */
const updateProject = ({ commit, dispatch, state }) => {
  const url = '/Project/Update';
  const params = state.currentProject;

  return api
    .post(url, params)
    .then((response) => {
      const valid = ResponseHelper.processResponse(response, commit, 'updateProject') && response.data;
      if (valid) {
        commit('hydrateCurrentProject', response.data);
        return response.data;
      } else {
        dispatch('app/showError', response.Errors, { root: true });
        return response.Errors;
      }
    })
    .catch((error) => {
      dispatch('app/showError', error, { root: true });
      return error;
    });
};
/**
 * Applies a discount to the project.
 * @param {*} param0
 * @param {*} payload
 * @returns
 */
const applyDiscount = ({ commit, dispatch }, payload) => {
  const url = '/Project/ApplyDiscount';
  const params = payload;

  return api.post(url, params).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'applyDiscount') && response.data;
    if (valid) {
      commit('hydrateCurrentProject', response.data);
      return response.data;
    } else {
      dispatch('app/showError', response.Errors, { root: true });
      return response.Errors;
    }
  });
};
/**
 * Creates a new project from a template.
 *
 * @param {Object} context - The Vuex context object.
 * @param {string} templateId - The ID of the template to create the project from.
 * @returns {Promise} A promise that resolves to the created project data or an error message.
 */
const createFromTemplate = ({ commit, dispatch }, templateId) => {
  const url = `/Project/CreateFromTemplate/${templateId}`;

  return api.post(url).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'createFromTemplate') && response.data;
    if (valid) {
      return response.data;
    } else {
      dispatch('app/showError', response.Errors, { root: true });
      return response.Errors;
    }
  });
};
/**
 * Raises a sig event.
 *
 * @param {Object} context - The context object.
 * @param {Object} payload - The payload object.
 * @returns {Promise} A promise that resolves when the API call is completed.
 */
const raiseSigEvent = ({ commit }, payload) => {
  const url = '/Configurator/GetSigBehaviors';
  const params = payload;

  return api.post(url, params).then((response) => {
    if (typeof response.data !== 'undefined' && Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }
  });
};
// #endregion

// #region : Create Entities :
/**
 * Creates a new Project
 * @param {*} param0
 * @param {*} systemTypeId
 * @returns
 */
const createProject = ({ commit }, payload) => {
  const url = '/Project/Create';
  const params = {
    id: 0,
    name: payload.name,
    sellPrice: 0,
    budget: payload.budget,
    completionDate: payload.completionDate,
    notes: payload.notes,
    projectSettingModels: payload.projectSettingModels
  };
  return api.post(url, params).then((response) => {
    const valid = ResponseHelper.processResponse(response, commit, 'createProject');

    if (valid) {
      return response.data;
    } else {
      return response.Errors;
    }
  });
};
/**
 * Creates a new System
 * @param {*} param0
 * @param {*} systemTypeId
 */
const createSystem = ({ state, commit }, systemTypeId) => {
  commit('setSavingNewSystem', true);

  let newSystem = state.availableSystemDefinitions.find((x) => x.systemDefinitionId === systemTypeId);
  newSystem.projectId = state.currentProject.id;

  const url = '/System/Create';
  const params = newSystem;

  return api.post(url, params).then((response) => {
    commit('setSavingNewSystem', false);
    const valid = ResponseHelper.processResponse(response, commit, 'createSystem');

    if (valid) {
      // do something
    } else {
      return response.Errors;
    }
  });
};
/**
 * Creates a new Subsystem
 * @param {*} param0
 * @param {*} payload
 */
const createSubsystem = ({ state, commit }, payload) => {
  commit('setSavingNewSubsystem', true);

  let subsystemDefinition = state.availableSubsystemDefinitions.find(
    (x) => x.subsystemDefinitionId === payload.subsystemDefinitionId
  );

  const url = '/Subsystem/Create';
  const params = {
    id: 0,
    systemId: payload.systemId,
    subsystemDefinitionId: subsystemDefinition.id,
    systemDefinitionId: subsystemDefinition.systemDefinitionId,
    name: subsystemDefinition.name,
    description: subsystemDefinition.description,
    subsystemType: subsystemDefinition.subsystemType,
    sellPrice: 0,
    percentComplete: 0,
    componentModels: [],
    stepModels: []
  };

  return api.post(url, params).then((response) => {
    commit('setSavingNewSubsystem', false);
    const valid = ResponseHelper.processResponse(response, commit, 'createSubsystem');

    if (valid) {
      return response.data;
    } else {
      return response.Errors;
    }
  });
};
// #endregion

// #region : Delete Entities :
/**
 * Deletes a project
 * @param {*} param0
 * @param {*} id
 */
const deleteProject = ({ commit }, id) => {
  commit('setProjectsLoading', true);

  const url = '/Project/Delete/' + id;

  return api.delete(url).then((response) => {
    commit('setProjectsLoading', false);
    ResponseHelper.processResponse(response, commit, 'deleteProject');
  });
};
/**
 * Deletes a System
 * @param {*} param0
 * @param {*} id
 */
const deleteSystem = ({ commit }, id) => {
  commit('setSystemsLoading', true);

  const url = '/System/Delete/' + id;

  return api.delete(url).then((response) => {
    commit('setSystemsLoading', false);
    ResponseHelper.processResponse(response, commit, 'deleteSystem');
  });
};
/**
 * Deletes a Subsystem
 * @param {*} param0
 * @param {*} id
 */
const deleteSubsystem = ({ commit }, id) => {
  commit('setSubsystemsLoading', true);

  const url = '/Subsystem/Delete/' + id;

  return api.delete(url).then((response) => {
    commit('setSubsystemsLoading', false);
    ResponseHelper.processResponse(response, commit, 'deleteSubsystem');
  });
};
// #endregion

export default {
  getProjects,
  getSystems,
  getProject,
  getProjectSettingDefinitions,
  createSystem,
  applyDiscount,
  getSystem,
  getSubsystem,
  validateComponent,
  updateProject,
  createFromTemplate,
  raiseSigEvent,
  getAvailableSystems,
  getAvailableSubsystems,
  getSubsystems,
  getStepComponent,
  getSubsystemSteps,
  refreshTreeSummaryData,
  deleteProject,
  deleteSystem,
  deleteSubsystem,
  createProject,
  createSubsystem,
  configureProductAccessory,
  configureProduct,
  duplicateAccessory,
  getSubsystemDetails,
  getSystemsForCheckout
};
